import { createSelector } from 'reselect'
import createSortedCardStatusesSelector from '../../selectors/createSortedCardStatusesSelector'
import createCardStatusSelector from '../../selectors/createCardStatusSelector'
import createSortedLabelsSelector from '../../selectors/createSortedLabelsSelector'

export const getCard = (state, props) => {
  return state['view-board'].cards[props.id]
}

export const getCardsById = (state, props) => {
  return state['view-board'].cards
}

export const getCardRelations = (state, props) => {
  return state.kanbo.cardRelations.byId[props.id]
}

export const getStartDate = (state, props) => {
  return state['view-board'].cards[props.id].startDate
}

const createCardIdsSelector = () => createSelector(
  [
    (state, props) => state['view-board'].view[props.boardContext.id].lists,
    (state, props) => state['view-board'].lists,
  ],
  (
    listIds,
    listsById,
  ) =>
    listIds.reduce((cardIds, listId) => cardIds.concat(listsById[listId].cards), [])
)

const createCalendarDateSelector = () => {
  const cardIdsSelector = createCardIdsSelector()

  return createSelector(
    [getCardRelations, cardIdsSelector, getCardsById, getStartDate],
    (cardRelations, localCardsIds, cardsById, startDate) => {
      if (cardRelations && !startDate) {
        const allParents = cardRelations.parentIds.map(String)
        const localParents = allParents.filter(parent => localCardsIds.includes(parent))

        if (localParents.length === 1 && cardsById[localParents[0]]) {
          const parent = cardsById[localParents[0]]
          return parent.startDate ? parent.startDate : (parent.dueDate ? parent.dueDate : null)
        } else {
          return null
        }
      } else {
        return startDate ? startDate : null
      }
    }
  )
}

const getCardId = (state, props) => {
  return props.id
}

const getCardStatusIds = (state, props) => {
  return state['view-board'].cardStatuses[props.boardContext.id].ids
}

const getLabels = (state, props) => {
  return state['view-board'].labels[props.boardContext.id].labels
}

export default () => {
  const sortedCardStatusesSelector = createSortedCardStatusesSelector(getCardStatusIds)
  const cardStatusSelector = createCardStatusSelector(getCardId, getCardStatusIds)
  const calendarDateSelector = createCalendarDateSelector()
  const sortedLabelsSelector = createSortedLabelsSelector(getLabels)

  return createSelector(
    [getCard, sortedCardStatusesSelector, cardStatusSelector, sortedLabelsSelector, calendarDateSelector],
    (card, cardStatuses, status, boardLabels, calendarDate) => {
      return {
        name: card.name,
        responsible: card.responsible,
        users: card.users,
        cardStatuses,
        status,
        labels: card.labels,
        boardLabels,
        startDate: card.startDate,
        dueDate: card.dueDate,
        calendarDate
      }
    }
  )
}
